export default class AllocationExceededError extends Error {
  constructor(message) {
    super(message)
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AllocationExceededError)
    }
    this.name = 'AllocationExceededError'
    // Custom debugging information
    this.errorDate = new Date()
  }
}
